import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { observer } from 'mobx-react';
import CodeCellStore from '../stores/CodeCellStore';

export interface ResultProps {
  store: CodeCellStore;
}

@observer
export default class Result extends React.Component<ResultProps> {

  render() {
    const { data } = this.props.store;
    const { columns, rows } = convertData(data);

    // tslint:disable-next-line:no-console
    console.log('Processed results:', columns, rows);

    return (
      <ReactTable
        data={rows}
        columns={columns}
        showPagination={false}
        pageSize={rows.length}
        defaultPageSize={rows.length}
        className="-striped -highlight"
        style={{ border: '1px solid #333' }}
      />
    );
  }
}

function convertData(data: object): { columns: Column[]; rows: any[] } {
  const colMap: { [k: string]: string } = {
    name: 'Name',
    type: 'Type',
    value: 'Value'
  };
  const rows = Object.keys(data).map((k: string) => {
    const o = data[k];
    if (o instanceof Array || !(o instanceof Object)) {
      const type: string = o instanceof Array ? 'array' : typeof o;
      return { name: k, value: JSON.stringify(o), type };
    } else if (o instanceof Object) {
      const values = Object.keys(o).reduce((obj, oKey) => {
        if (!colMap[oKey]) {
          colMap[oKey] = oKey.substr(0, 1).toUpperCase() + oKey.substr(1, oKey.length - 1);
        }
        obj[oKey] = JSON.stringify(o[oKey]);
        return obj;
      }, {});
      return { name: k, ...values };
    }
    return data;
  });

  return {
    columns: [
      {
        Header: <b>Context data</b>,
        headerStyle: { backgroundColor: '#1a1a1a' },
        columns: Object.keys(colMap).reduce((cols, k) => {
          const col: any = {
            Header: colMap[k],
            accessor: k,
          };
          if (col.accessor === 'name') {
            col.maxWidth = 140;
          }
          if (col.accessor === 'type') {
            col.maxWidth = 100;
          }
          return [ ...cols, col ];
        }, []),
      },
    ],
    rows,
  };
}
